export const tagsInputTabindexComponentModule = angular
  .module('Q.components.forms.tags-input-tabindex', [])

  .directive('tagsInput', function () {
    return {
      priority: -1,
      link: function (scope, elem) {
        elem.attr('tabindex', '-1');
      },
    };
  });
